import { QualityRepository } from '../../domain/repositories/quality.repository';
import { QualityEntity } from '../../domain/entities/quality.entity';

export class GetQualitiesUseCase {
  constructor(private readonly qualityRepository: QualityRepository) {}

  async execute(options?: {
    activeOnly?: boolean;
    search?: string;
  }): Promise<QualityEntity[]> {
    return this.qualityRepository.getQualities(options);
  }
}
